module.exports = __webpack_public_path__ + "img/NHSO.784b824b.jpg";